// client/helper/toggleMark.ts
import { doesMarkMatchAttributes } from "./doesMarkMatchAttributes.js";
function toggleMark({
  markName,
  view,
  attrs
}) {
  return (state, dispatch) => {
    const { schema, tr, selection } = state;
    const { from, to, empty } = selection;
    const markType = schema.marks[markName];
    if (!markType) {
      throw new Error(`No mark with identifier '${markName}' found in schema`);
    }
    const isMarkActive = () => {
      if (empty) {
        const marks = state.storedMarks || selection.$from.marks();
        return marks.some((mark) => mark.type === markType && doesMarkMatchAttributes(mark, attrs));
      } else {
        let match = false;
        state.doc.nodesBetween(from, to, (node) => {
          if (node.isText) {
            const mark = node.marks.find((m) => m.type === markType);
            if (mark && doesMarkMatchAttributes(mark, attrs)) {
              match = true;
            }
          }
        });
        return match;
      }
    };
    const attrsMatch = isMarkActive();
    if (!dispatch) {
      return attrsMatch;
    }
    if (attrsMatch) {
      if (empty) {
        tr.removeStoredMark(markType);
      } else {
        tr.removeMark(from, to, markType);
      }
    } else {
      if (empty) {
        tr.addStoredMark(markType.create(attrs));
      } else {
        tr.addMark(from, to, markType.create(attrs));
      }
    }
    dispatch(tr);
    view.focus();
    return true;
  };
}
export {
  toggleMark
};
